import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Button from '../components/ui/Button';
import { Link } from 'react-router-dom';
import image1 from '../assets/images/innovation/Image-1.jpg';
import image2 from '../assets/images/innovation/image-2.jpg';
import image3 from '../assets/images/innovation/image-3.jpg';
import image4 from '../assets/images/innovation/image-4.jpg';
import image5 from '../assets/images/innovation/image-5.jpg';
import image6 from '../assets/images/innovation/image-6.jpg';
import image7 from '../assets/images/innovation/image-7.jpg';
import image8 from '../assets/images/innovation/image-8.jpg';
import image9 from '../assets/images/innovation/image-9.jpg';
import image10 from '../assets/images/innovation/image-10.png';
import image11 from '../assets/images/innovation/image-11.png';
import boxicon from '../assets/icons/box icon.png';


const Innovation = () => {
  return (
    <div className="bg-cream text-[#3b1b0d] font-sans">
      <Header />

      {/* ---------------- HERO SECTION ---------------- */}
      <section className="py-24 bg-cream">
        <div className="flex flex-col items-center gap-12 px-6 mx-auto max-w-7xl lg:px-12 lg:flex-row-reverse">
          <div className="flex-1">
            <img
              src={image1}
              alt="Innovation"
              className="w-full h-[460px] object-cover rounded-3xl shadow-lg"
            />
          </div>

          <div className="flex-1 max-w-xl">
            <h1 className="mb-6 text-5xl font-semibold leading-tight md:text-6xl text-text-primary">
              Lead The Change—<br />Bake With Innovation!
            </h1>
            <p className="mb-8 text-lg text-text-primary">
              From ultrasonic cutting to clean-label improvers, Enessa Foods is revolutionizing Indian baking with advanced technologies and next-gen ingredient solutions tailored for real-world success..
            </p>
            <div className="flex flex-wrap gap-4">
              <Link to="/contact">
                <Button variant="primary" size="medium">Contact Us</Button>
              </Link>
              <Link to="/products">
                <Button variant="secondary">View Products</Button>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* ---------------- ACHIEVEMENTS SECTION ----------------
      <section className="py-20 bg-cream">
        <div className="px-6 mx-auto text-center max-w-7xl lg:px-12">
         
          <h2 className="mb-4 text-4xl font-bold text-text-primary">
            Achievements That Shaped Our Journey
          </h2>
          <p className="mb-12 text-text-primary">
            Innovation is not just our promise—it’s our proven track record. Explore some of Enessa Foods’ breakthrough achievements that redefined baking standards in India..
          </p>

          <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
             {[
              { year: '2020', title: 'Pioneering Egg-Free Cake Premixes', desc: 'We pioneered egg-free cake premixes in India—giving bakeries the ability to craft high-quality, vegan-friendly cakes at scale..' },
              { year: '2021', title: 'Encapsulated Acids for Preservation', desc: 'First in India to introduce encapsulated sorbic & fumaric acids, allowing gradual release for longer freshness—without compromising taste.' },
              { year: '2022', title: 'ENESSA BAKE DIAMOND Improver', desc: 'An industry-favorite improver tailored for chakki atta breads, enhancing softness, volume & consistency in tough Indian climates.' },
            ].map((item, idx) => (
              <div key={idx} className="bg-white p-8 rounded-3xl shadow-sm border border-[#f2e1c5] hover:shadow-md transition-all text-left">
                <img src={boxicon} alt="Chef"/>
                <div className="text-[#b42b2b] font-semibold mb-2">{item.year}</div>
                
                <h3 className="text-xl font-semibold mb-3 text-[#3b1b0d]">{item.title}</h3>
                <p className="text-[#7b5b3a] text-sm">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section> */}

      {/* ---------------- TIMELINE SECTION ----------------
      <section className="py-16 lg:py-24 bg-cream">
  <div className="px-6 mx-auto max-w-7xl lg:px-12">
    {/* Header - Centered *
    <div className="mb-16 text-center lg:mb-20">
      <div className="inline-block mb-2">
        <span className="text-[#b42b2b] text-xs font-semibold tracking-wider uppercase">COLLABORATION & FUTURE</span>
      </div>
      <h2 className="mb-3 text-3xl font-bold lg:text-5xl text-text-primary">
        Trace Our Trailblazing Journey
      </h2>
      <p className="max-w-3xl mx-auto text-base text-text-primary lg:text-lg">
        A journey of innovation, collaboration and transformation in India's bakery industry.
      </p>
    </div>

    {/* Timeline *
    <div className="space-y-16 lg:space-y-24">
      {[
        { 
          year: 'YEAR 1994',
          title: 'Establishment', 
          desc: 'Launched as a premier provider of innovative bakery ingredients and solutions tailored for Indian conditions.',
          image: image3,
          align: 'left'
        },
        { 
          year: 'YEAR 2000',
          title: 'Egg-Free Cake Premixes', 
          desc: 'Successfully launched India\'s first comprehensive line of egg-free cake premixes, offering a cost-effective solution for vegan bakeries.',
          image: image4,
          align: 'right'
        },
        { 
          year: 'YEAR 2005',
          title: 'Encapsulated Acid Technology', 
          desc: 'Pioneered encapsulated preservatives, improving the shelf life of bakery products without affecting their flavor or texture.',
          image: image5,
          align: 'left'
        },
        { 
          year: 'YEAR 2010',
          title: 'Custom Improver Solutions', 
          desc: 'Collaborated with leading bakery chains to create custom improver blends that addressed key industry challenges such as bread staling in hot climates and whole-wheat atta consistency.',
          image: image6,
          align: 'right'
        },
        { 
          year: 'YEAR 2015',
          title: 'Innovation Recognition', 
          desc: 'Enessa Foods became a trusted development partner for bakeries seeking to create trend-setting products and modernize their production processes.',
          image: image7,
          align: 'left'
        },
        { 
          year: 'YEAR 2020',
          title: 'Customer Adoption', 
          desc: 'Our innovations like ENESSA BAKE DIAMOND have been adopted across the country, helping bakeries create high-quality, consistent baked goods.',
          image: image8,
          align: 'right'
        },
      ].map((item, idx) => (
        <div key={idx} className="relative">
          {/* Mobile Layout *
          <div className="flex flex-col gap-6 lg:hidden">
            {/* Image *
            <div className="relative">
              <div className="overflow-hidden shadow-lg rounded-3xl">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-[280px] object-cover"
                />
              </div>
              {/* Red dot on image *
              <div className="absolute -top-2 right-6">
                <div className="w-3 h-3 bg-[#b42b2b] rounded-full"></div>
              </div>
            </div>

            {/* Content Card *
            <div className="p-6 shadow-sm bg-cream rounded-3xl">
              <p className="text-[#b42b2b] text-xs font-bold tracking-wider mb-2 uppercase">
                {item.year}
              </p>
              <h4 className="mb-3 text-xl font-bold text-text-primary">
                {item.title}
              </h4>
              <p className="mb-5 text-sm leading-relaxed text-text-primary">
                {item.desc}
              </p>
              
              <div className="flex flex-wrap gap-3">
                <button className="px-5 py-2 bg-[#b42b2b] text-white rounded-full text-sm font-medium flex items-center gap-2 hover:bg-[#8f2222] transition-colors">
                  <span></span>
                  Contact Us
                </button>
                <button className="px-5 py-2 bg-transparent text-[#b42b2b] rounded-full text-sm font-medium flex items-center gap-2 hover:bg-white transition-colors">
                  {idx % 2 === 0 ? 'About Us' : 'View Products'}
                  <span>→</span>
                </button>
              </div>
            </div>
          </div>*

          {/* Desktop Layout *
          <div className={`hidden lg:flex items-start gap-12 ${item.align === 'right' ? 'flex-row-reverse' : ''}`}>
            {/* Image Side *
            <div className="relative flex-1">
              <div className="overflow-hidden shadow-xl rounded-3xl">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-[400px] object-cover"
                />
              </div>
              {/* Red dot indicator *
              <div className={`absolute -top-3 ${item.align === 'right' ? 'left-8' : 'right-8'}`}>
                <div className="w-3 h-3 bg-[#b42b2b] rounded-full"></div>
              </div>
            </div>

            {/* Content Side *
            <div className="flex-1">
              <div className="p-10 shadow-lg bg-cream rounded-3xl">
                <p className="text-[#b42b2b] text-xs font-bold tracking-wider mb-3 uppercase">
                  {item.year}
                </p>
                <h4 className="mb-4 text-3xl font-bold text-text-primary">
                  {item.title}
                </h4>
                <p className="mb-6 text-lg leading-relaxed text-text-primary">
                  {item.desc}
                </p>
                
                <div className="flex flex-wrap gap-3">
                  <Link to="/contact">
                  <Button variant="primary" size="medium">Contact Us</Button>
                </Link>
                <Link to="/products">
                  <Button variant="secondary" size="medium">view products</Button>
                </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  </div>
</section> */}

  
      {/* ---------------- FUTURE OF BAKING SECTION ---------------- */}
<section className="py-16 lg:py-24 bg-cream">
  <div className="px-6 mx-auto max-w-7xl lg:px-12">
    {/* Header - Centered */}
    <div className="mb-16 text-center lg:mb-20">
      <div className="inline-block mb-3">
        <span className="text-[#b42b2b] text-xs font-semibold tracking-wider uppercase flex items-center gap-2">
          <span className="text-lg"></span>
          COLLABORATION & FUTURE
        </span>
      </div>
      <h2 className="mb-4 text-3xl font-bold leading-tight lg:text-5xl text-text-primary">
        What If The Future Of Baking<br />Started With You?
      </h2>
      <p className="max-w-3xl mx-auto text-base text-text-primary lg:text-lg">
        At Enessa Foods, innovation is a collaborative journey. We partner with you to create the future of baking.
      </p>
    </div>

    {/* Grid Layout */}
    <div className="grid gap-8 lg:grid-cols-3 lg:gap-12">
      {/* Left Column */}
      <div className="space-y-12 lg:space-y-16">
        {/* Data-Driven Baking Excellence */}
        <div className="text-left">
          <div className="mb-4">
            <div className="flex items-center justify-center w-12 h-12 mb-4 text-text-primary rounded-xl">
              {/* <span className="text-2xl"></span> */}<div className="flex-1">
              <img src={boxicon} alt="Chef" className="w-full shadow-2xl rounded-3xl" />
            </div>
            </div>
            <p className="text-[#b42b2b] text-xs font-bold tracking-wider uppercase mb-2">
              DIGITAL PROCESS MONITORING
            </p>
            <h4 className="mb-3 text-2xl font-bold lg:text-3xl text-text-primary">
              Data-Driven Baking Excellence
            </h4>
          </div>
          <p className="text-sm leading-relaxed text-text-primary lg:text-base">
            Our digital solutions provide real time process monitoring, giving you the tools to track and optimize production. These innovations will transform the bakery industry by making operations more data-driven, efficient, and precise.
          </p>
        </div>

        {/* Future-Proof Bakery Solutions */}
        <div className="text-left">
          <div className="mb-4">
            <div className="flex items-center justify-center w-12 h-12 mb-4 text-text-primary rounded-xl">
              <img src={boxicon} alt="Chef" className="w-full shadow-2xl rounded-3xl" />
            </div>
            <h4 className="mb-3 text-2xl font-bold lg:text-3xl text-text-primary">
              Future-Proof Bakery Solutions
            </h4>
          </div>
          <p className="text-sm leading-relaxed text-text-primary lg:text-base">
            We're investing in fiber-rich, protein-forward, and plant-powered solutions that meet tomorrow's baking demands—today.
          </p>
        </div>

        {/* Partnering For Progress */}
        <div className="text-left">
          <div className="mb-4">
            <div className="flex items-center justify-center w-12 h-12 mb-4 text-text-primary rounded-xl">
              <img src={boxicon} alt="Chef"/>
            </div>
            <h4 className="mb-3 text-2xl font-bold lg:text-3xl text-text-primary">
              Partnering For Progress
            </h4>
          </div>
          <p className="text-sm leading-relaxed text-text-primary lg:text-base">
            We welcome feedback from bakers like you to co-create next-gen products for solving unique production challenges together with real-world solutions.
          </p>
        </div>
      </div>

      {/* Center Column - Images */}
      <div className="flex flex-col justify-center space-y-12 lg:space-y-16">
        {/* Quality Assurance Illustration */}
        <div className="relative">
          <div className="p-8 bg-white shadow-lg rounded-3xl lg:p-12">
            <img
              src={image10}
              alt="Quality Assurance"
              className="w-full h-auto"
            />
          </div>
          {/* Decorative gears */}
          <div className="absolute text-gray-300 -top-4 -left-4">
            <span className="text-4xl"></span>
          </div>
          <div className="absolute text-gray-300 -bottom-4 -left-6">
            <span className="text-5xl"></span>
          </div>
        </div>

        {/* Cake Illustration */}
        <div className="relative">
          <div className="overflow-hidden shadow-lg rounded-3xl">
            <img
              src={image11}
              alt="Bakery Innovation"
              className="w-full h-auto"
            />
          </div>
          {/* Decorative stars */}
          <div className="absolute transform -translate-x-1/2 -top-6 left-1/2">
            <div className="flex gap-2">
              <span className="text-2xl text-[#b42b2b]"></span>
              <span className="text-3xl text-[#b42b2b]"></span>
              <span className="text-2xl text-[#b42b2b]"></span>
            </div>
          </div>
        </div>
      </div>

      {/* Right Column */}
      <div className="space-y-12 lg:space-y-16">
        {/* Plant-Based Ingredients */}
        <div className="text-left">
          <div className="mb-4">
            <div className="flex items-center justify-center w-12 h-12 mb-4 text-text-primary rounded-xl">
              <img src={boxicon} alt="Chef" className="w-full shadow-2xl rounded-3xl" />
            </div>
            <h4 className="mb-3 text-2xl font-bold lg:text-3xl text-text-primary">
              Plant-Based Ingredients
            </h4>
          </div>
          <p className="text-sm leading-relaxed text-text-primary lg:text-base">
            We're developing sustainable, plant-based ingredients that support India's rising demand for nutritious, eco-conscious bakery products.
          </p>
        </div>

        {/* Enhanced Natural Preservatives */}
        <div className="text-left">
          <div className="mb-4">
            <div className="flex items-center justify-center w-12 h-12 mb-4 text-text-primary rounded-xl">
              <img src={boxicon} alt="Chef" className="w-full shadow-2xl rounded-3xl" />
            </div>
            <h4 className="mb-3 text-2xl font-bold lg:text-3xl text-text-primary">
              Enhanced Natural Preservatives
            </h4>
          </div>
          <p className="text-sm leading-relaxed text-text-primary lg:text-base">
            Say goodbye to synthetic additives—our natural preservative systems keep baked goods fresh, clean-label, and shelf-stable.
          </p>
        </div>

        {/* Smarter Baking With Technology */}
        <div className="text-left">
          <div className="mb-4">
            <div className="flex items-center justify-center w-12 h-12 mb-4 text-text-primary rounded-xl">
              <img src={boxicon} alt="Chef" className="w-full shadow-2xl rounded-3xl" />
            </div>
            <p className="text-[#b42b2b] text-xs font-bold tracking-wider uppercase mb-2">
              INDUSTRY 4.0 IN BAKING
            </p>
            <h4 className="mb-3 text-2xl font-bold lg:text-3xl text-text-primary">
              Smarter Baking With Technology
            </h4>
          </div>
          <p className="text-sm leading-relaxed text-text-primary lg:text-base">
            Enessa Foods is also exploring the Industry 4.0 solutions, integrating IoT and smart sensors into bakery production. This allows us to optimize ovens, mixers, and processes for perfect, consistent results every time, boosting both quality and efficiency.
          </p>
        </div>
      </div>
    </div>
  </div>
</section>

      {/* Future Vision */}
      <section className="py-16 lg:py-24 bg-cream">
  <div className="px-6 mx-auto max-w-7xl lg:px-12">
    {/* Header Section */}
    <div className="flex flex-col gap-8 mb-12 lg:flex-row lg:gap-12 lg:mb-16">
      {/* Left - Title */}
      <div className="lg:w-1/2">
        <h2 className="text-3xl font-bold leading-tight lg:text-5xl text-text-primary">
          Redefining The Future Of Baking One Innovation At A Time
          <span className="inline-block ml-3 align-middle">
            <div className="flex items-center justify-center w-10 h-10 rounded-lg lg:w-12 lg:h-12 text-text-primary">
              <img src={boxicon} alt="Chef" className="w-full shadow-2xl rounded-3xl" />
            </div>
          </span>
        </h2>
      </div>

      {/* Right - Description */}
      <div className="lg:w-1/2">
        <p className="text-base leading-relaxed text-text-primary lg:text-lg">
          Our vision is to continuously set new standards in the bakery ingredients sector. By focusing on sustainable, health-conscious, and efficiency-boosting innovations, we aim to help our customers lead in their markets. <span className="font-bold text-[#2c1810]">Enessa Foods</span> remains at the cutting edge of technological advancements, fresh ideas and innovative products, ensuring you always have access to the latest and most advanced ingredient solutions.
        </p>
      </div>
    </div>

    {/* Single Large Image */}
    <div className="overflow-hidden shadow-2xl rounded-3xl">
      <img
        src={image2}
        alt="Modern bakery with fresh bread and ingredients"
        className="w-full h-[400px] lg:h-[600px] object-cover"
      />
    </div>
  </div>
</section>

      {/* CTA */}
      <section className="py-24 bg-white lg:py-40 lg:bg-cream">
        <div className="px-6 mx-auto bg-white lg:bg-cream max-w-7xl lg:px-8">
          <div className="bg-white rounded-[40px] p-12 lg:p-24 shadow-soft flex flex-col lg:flex-row-reverse items-center gap-16">
            <div className="flex-1">
              <img src={image9} alt="Chef" className="w-full shadow-2xl rounded-3xl" />
            </div>
            <div className="flex-1 text-center bg-white lg:text-left">
              <h2 className="mb-8 leading-tight font-heading text-heading-lg text-text-primary">
                Need a special solution?<br className="hidden lg:block" /> Talk to our innovation team.
              </h2>
              <p className="mb-10 leading-normal font-body text-body-lg text-text-primary">
                Enessa Foods is ready to collaborate on R&D projects or pilot programs to bring the next big bakery innovation to life – together with you.
              </p>
              <div className="flex flex-wrap justify-center gap-6 lg:justify-start">
                <Link to="/contact"><Button variant="primary" size="large">Contact Us</Button></Link>
                <Link to="/contact#inquiry-section"><Button variant="secondary" size="large">Enquiry Form</Button></Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};
export default Innovation;
